import en from "./element.en-GB.js";

export default {
  ...en,
  common: {
    ...en.common,
    cancel: "Cancelar",
    close: "Cerrar",
    edit: "Editar",
    archive: "Archivar",
    deactivate: "Desactivar",
    confirm: "Confirmar",
    none: "Ninguno",
    unknown: "Desconocido",
    unavailable: "No disponible",
    system: "Sistema",
    yes: "Sí",
    no: "No",
    loading: "Cargando",
    notRecorded: "Sin registrar",
    notSelected: "Sin seleccionar",
    noReason: "Sin motivo",
    unassigned: "Sin asignar",
    sensor: "Sensor",
    gateway: "Gateway",
    device: "Dispositivo Element",
    elementSensor: "Sensor Element",
    metric: "Métrica",
    email: "Correo electrónico",
    messages: "Mensajes",
    needed: "Necesario",
    ready: "Listo",
    noValue: "Sin valor",
    tracked: "Localizado",
    select: "Seleccionar",
    resolved: "resuelta",
    channels: "canales",
    staff: "miembros del personal",
    emails: "correos",
    until: "hasta",
    model: "Modelo",
    location: "Ubicación",
    status: "Estado",
    notes: "Notas",
    name: "Nombre",
    description: "Descripción",
    serialNumber: "Número de serie",
    installLocation: "Ubicación de instalación",
    lastSeen: "Última conexión",
    latestReading: "Última lectura",
    maintenance: "Mantenimiento",
    enabled: "Habilitada",
    disabled: "Deshabilitada",
    immediate: "Inmediata",
    minutes: "{count} minutos",
    minute: "{count} minuto",
    level: "Nivel {level}",
    and: "Y",
    countSensors: "{count} sensores",
    countSensor: "{count} sensor",
    countSelectedSensors: "{count} sensores seleccionados",
    countSelectedSensor: "{count} sensor seleccionado",
    breachPoint: "{count} punto fuera de rango en el periodo seleccionado.",
    breachPoints: "{count} puntos fuera de rango en el periodo seleccionado.",
    resultReadings: "{count} lecturas",
    resultReading: "{count} lectura",
    ending: "terminada en {suffix}",
  },
  enum: {
    area: {
      multi_purpose: "Multiusos",
      restroom: "Aseo",
      kitchen: "Cocina",
      plant_room: "Sala de instalaciones",
      accommodation: "Alojamiento",
      outdoor: "Exterior",
      wellness: "Bienestar",
      pool_spa: "Piscina / spa",
      gym: "Gimnasio",
      custom: "Personalizada",
      general_building: "Edificio general",
      restrooms: "Aseos",
      kitchens: "Cocinas",
      boiler_plant_rooms: "Salas de calderas / instalaciones",
      residence_hotel_rooms: "Residencias / habitaciones de hotel",
    },
    icon: {
      building: "Edificio",
      restroom: "Aseo",
      utensils: "Utensilios",
      settings: "Ajustes",
      bed: "Cama",
      tree: "Árbol",
      pool: "Piscina",
      dumbbell: "Mancuerna",
      shield: "Escudo",
      custom: "Personalizado",
    },
    colour: {
      emerald: "Esmeralda",
      blue: "Azul",
      amber: "Ámbar",
      purple: "Morado",
      gold: "Dorado",
      green: "Verde",
      slate: "Gris pizarra",
    },
    status: {
      active: "Activa",
      inactive: "Inactiva",
      archived: "Archivada",
      online: "En línea",
      offline: "Sin conexión",
      maintenance: "Mantenimiento",
      open: "Activa",
      acknowledged: "Confirmada",
      resolved: "Resuelta",
      suppressed: "Suprimida",
      draft: "Borrador",
      adopted: "Adoptado",
      provisioning: "Aprovisionando",
      pending_activation: "Activación pendiente",
      failed: "Fallido",
      normal: "Normal",
      warning: "Aviso",
      critical: "Crítico",
      info: "Información",
      unknown: "Desconocido",
      compliant: "Conforme",
      attention: "Requiere atención",
      not_started: "Sin iniciar",
      scheduled: "Programado",
      retired: "Retirado",
      disabled: "Deshabilitada",
    },
    metric: {
      temperature: "Temperatura",
      humidity: "Humedad",
      battery: "Batería",
      signal: "Señal",
      gateway_online: "Gateway en línea",
      sensor_online: "Sensor en línea",
      co2: "CO₂",
      pm2_5: "PM2,5",
      pm10: "PM10",
      fill_level: "Nivel de llenado",
      rainfall: "Precipitación",
      wind_speed: "Velocidad del viento",
      water_leak: "Fuga de agua",
      door_state: "Estado de la puerta",
      vape_detected: "Vapeo detectado",
      fall_detected: "Caída detectada",
      presence: "Presencia",
      odor_level: "Nivel de olor",
      location: "Ubicación",
      movement: "Movimiento",
      compound: "Condiciones compuestas",
    },
    condition: {
      below: "por debajo de",
      above: "por encima de",
      equals: "igual a",
      not_reporting: "sin informar",
    },
    severity: { info: "Información", warning: "Aviso", critical: "Crítica" },
    health: {
      normal: "Normal",
      warning: "Aviso",
      critical: "Crítico",
      offline: "Sin conexión",
    },
    action: {
      triggered: "Activada",
      acknowledged: "Confirmada",
      assigned: "Asignada",
      resolved: "Resuelta",
      auto_resolved: "Resuelta automáticamente",
      suppressed: "Suprimida",
      maintenance_suppressed: "Suprimida durante el mantenimiento",
      notification_sent: "Notificación enviada",
      notification_failed: "Error de notificación",
      escalation_sent: "Escalado enviado",
    },
    reading: {
      leak: "Fuga",
      dry: "Seco",
      open: "Abierta",
      closed: "Cerrada",
      detected: "Detectado",
      clear: "Sin detectar",
      occupied: "Ocupado",
      vacant: "Libre",
      elevated: "Elevado",
      normal: "Normal",
    },
    connection: {
      ethernet: "Ethernet",
      wifi: "Wi-Fi",
      cellular: "Móvil",
      lorawan: "LoRaWAN",
    },
    hardware: { gateway: "Gateway", sensor: "Sensor" },
  },
  range: {
    last24Hours: "Últimas 24 horas",
    last7Days: "Últimos 7 días",
    lastMonth: "Último mes",
    lastYear: "Último año",
    short24h: "24 h",
    short7d: "7 d",
    short1m: "1 mes",
    short1y: "1 año",
  },
  errors: {
    ...en.errors,
    invalidGatewayEui:
      "El EUI del gateway debe tener 16 caracteres hexadecimales.",
    gatewayAlreadyAdopted: "Este gateway ya está adoptado por el club.",
    chirpstackGatewayExists:
      "El gateway ya existe en ChirpStack; se vinculará con este club.",
    zoneKeyExists: "Ya existe una zona con esta clave.",
    deviceKeyExists: "Ya existe un dispositivo con esta clave.",
    invalidDevEui: "El DevEUI debe tener 16 caracteres hexadecimales.",
    invalidJoinEui: "El JoinEUI/AppEUI debe tener 16 caracteres hexadecimales.",
    invalidAppKey: "La AppKey debe tener 32 caracteres hexadecimales.",
    missingLorawanCredentials: "Se necesitan DevEUI, JoinEUI/AppEUI y AppKey.",
    thresholdRequired: "Introduce un valor de umbral.",
    notReportingRequired: "Introduce los minutos sin comunicación.",
    ruleNameRequired: "Introduce un nombre para la regla.",
    scopeSensorRequired: "Selecciona un sensor.",
    scopeZoneRequired: "Selecciona una zona.",
    scopeGatewayRequired: "Selecciona un gateway.",
    scopeGroupRequired: "Selecciona un grupo de sensores.",
    recipientRequired:
      "Selecciona al menos un destinatario del personal para Mensajes de Privana.",
    clubCodeMissing: "No se encontró el código del club en la ruta actual.",
    overviewLoad:
      "No se pudieron cargar los datos de supervisión de Privana Element.",
    zoneLoad: "No se pudieron cargar los detalles de la zona.",
    graphLoad: "No se pudo cargar el periodo del gráfico.",
    alertRulesLoad: "No se pudieron cargar las reglas de alerta.",
    alertCentreLoad: "No se pudo cargar el centro de alertas.",
    saveRule: "No se pudo guardar la regla de alerta.",
    deactivateRule: "No se pudo desactivar la regla.",
    saveZone: "No se pudo guardar la zona de Element.",
    saveDevice: "No se pudo guardar el dispositivo Element.",
    adoptHardware: "No se pudo adoptar el hardware.",
    updateHardware: "No se pudo actualizar el hardware.",
    assignSensor: "No se pudo asignar el sensor.",
    unassignSensor: "No se pudo desasignar el sensor.",
    archiveZone: "No se pudo archivar la zona.",
    deactivateDevice: "No se pudo desactivar el dispositivo.",
    refreshGateway: "No se pudo actualizar ahora el estado del gateway.",
    gatewaySyncFailed: "No se pudo sincronizar el gateway",
    startMaintenance: "No se pudo iniciar el mantenimiento.",
    endMaintenance: "No se pudo finalizar el mantenimiento.",
    actionAlert: "No se pudo {action} la alerta.",
    cameraDenied:
      "Se ha denegado el permiso de la cámara. Permite el acceso o pega el texto del QR.",
    cameraMissing:
      "No se encontró ninguna cámara en este dispositivo. Pega el texto del QR.",
    cameraStart:
      "No se pudo iniciar el escáner. Permite el acceso a la cámara, cierra otras aplicaciones que la usen o pega el texto del QR.",
    cameraUnavailable:
      "La cámara no está disponible en este contexto del navegador. Pega el texto o abre Privana mediante HTTPS.",
    scannerRegion:
      "El contenedor del escáner no se mostró antes de iniciar la cámara.",
    invalidPairing:
      "Este enlace de emparejamiento no es válido. Genera uno nuevo en el cuadro de diálogo del ordenador.",
    pairingConnect:
      "No se pudo conectar. Mantén esta página abierta e inténtalo de nuevo.",
    photoDecode:
      "No se pudo leer un código QR de esa foto. Llena el encuadre con el código QR e inténtalo de nuevo.",
    connecting:
      "Privana todavía se está conectando. Inténtalo de nuevo en unos instantes.",
  },
  dashboard: {
    loadingLabel: "Cargando el panel de Privana Element",
    filterZone: "Filtrar por zona",
    filterZonePlaceholder: "Filtrar por zona",
    allZones: "Todas las zonas",
    selectRange: "Seleccionar periodo",
    addZone: "Añadir zona",
    alertCentre: "Centro de alertas",
    manageAlerts: "Gestionar alertas",
    refresh: "Actualizar",
    gatewayRefreshed: "Estado del gateway actualizado",
    gatewayRefreshedHelp:
      "Se ha sincronizado el estado más reciente del gateway en ChirpStack.",
    lastRefreshed: "Última actualización: {date}",
    attention: "Privana Element requiere atención",
    retry: "Reintentar",
    kpiLabel: "Indicadores de Privana Element",
    systemHealth: "Estado del sistema",
    weightedEstate: "Puntuación ponderada de las instalaciones",
    activeAlerts: "Alertas activas",
    openAcknowledged: "Abiertas o confirmadas",
    sensorsOnline: "Sensores en línea",
    basedLastSeen: "Según su conexión reciente",
    zonesMonitored: "Zonas supervisadas",
    configuredZones: "Zonas Element configuradas",
    complianceStatus: "Estado de cumplimiento",
    fromCompliance: "Según los registros de cumplimiento",
    maintenanceDue: "Mantenimiento pendiente",
    dueNext14: "Vence en los próximos 14 días",
    noZones: "No hay zonas Element configuradas",
    noZonesHelp:
      "Crea zonas Element para el club y comienza a supervisar el edificio general, los aseos, las cocinas, las salas de instalaciones, las residencias y habitaciones de hotel y los exteriores.",
    monitoredZones: "Zonas supervisadas",
    monitoredZonesHelp:
      "Telemetría empresarial de seguridad, ambiente, higiene, cadena de frío y exteriores.",
  },
  zone: {
    unnamed: "Zona sin nombre",
    monitoredArea: "Área supervisada",
    sensors: "Sensores",
    online: "En línea",
    alerts: "Alertas",
    assignedWaiting: "Hay sensores asignados; esperando las primeras lecturas.",
    setupReady: "Configuración lista: asigna un sensor adoptado a esta zona.",
    view: "Ver zona",
    editLabel: "Editar {name}",
    archiveLabel: "Archivar {name}",
    detail: "Detalles de la zona",
    sensorDetail: "Detalles del sensor",
    expandedGraph: "Gráfico ampliado",
    loading: "Cargando zona…",
    back: "Atrás",
    backToSensor: "Volver al sensor",
    assignedToZone: "Asignados a la zona",
    latestMetricPoints: "Últimos puntos de medición",
    manage: "Gestionar zona",
    edit: "Editar zona",
    assignSensor: "Asignar sensor",
    noCatalogue: "No se ha seleccionado un modelo del catálogo",
    gatewayNetwork: "Gateway / red",
    noSensors: "No hay sensores asignados",
    noSensorsHelp:
      "Asigna un sensor adoptado y sin asignar para comenzar a recopilar telemetría de Element en esta zona.",
    latestReadings: "Últimas lecturas",
    noReadings: "No hay lecturas de esta zona",
    noReadingsHelp:
      "Las lecturas aparecerán cuando los dispositivos envíen telemetría.",
    create: "Crear zona",
    formHelp:
      "Configura cómo aparece esta área de Element en el panel de supervisión activo.",
    name: "Nombre de la zona",
    areaType: "Tipo de área",
    iconKey: "Icono",
    colourKey: "Color",
    descriptionPlaceholder: "Qué cubre esta zona…",
    exampleName: "Edificio general",
    save: "Guardar zona",
    archive: "Archivar zona",
    archivePrompt:
      "¿Archivar esta zona? Se conservarán las lecturas y alertas existentes.",
    archiveAction: "Archivar zona",
    archived: "Zona archivada",
    archivedHelp: "Se conservaron las lecturas y alertas existentes.",
    created: "Zona creada",
    updated: "Zona actualizada",
    refreshed: "Se han actualizado las zonas de Privana Element.",
    saveFailed: "No se pudo guardar la zona",
    archiveFailed: "No se pudo archivar",
  },
  readings: {
    temperatureShort: "Temp.",
    humidity: "Humedad",
    battery: "Batería",
    noNumericTitle: "No hay historial numérico de {metric}",
    noNumericHelp:
      "Aparecerá una línea de tendencia cuando se reciba telemetría numérica para esta métrica.",
    chartLabel: "Gráfico de tendencia de {metric}",
    expandLabel: "Ampliar el gráfico de {metric}",
    lastUpdated: "Última actualización: {date}",
    safeRange: "Rango seguro: {min} – {max}",
    noSafeRange:
      "No hay ningún umbral configurado para mostrar un rango seguro.",
    latestValue: "Último valor",
    selectedRange: "Periodo seleccionado",
    loadingRange: "Cargando el periodo seleccionado…",
    loading: "Cargando",
    sensorGraphs: "Gráficos del sensor",
    liveTelemetry: "Telemetría en directo de Element",
    defaultRange: "Periodo predeterminado: {range}",
    noHistory: "Aún no hay lecturas históricas",
    noHistoryHelp:
      "Las tarjetas de gráficos aparecerán cuando este sensor envíe datos de temperatura, humedad, batería u otras métricas de Element.",
    noThreshold: "No hay ningún umbral configurado",
    breach: "Fuera de rango: {reason}",
    thresholdLimit: "Límite del umbral: {limit}",
    severity: "Gravedad: {severity}",
    threshold: "Umbral: {name}",
  },
  panels: {
    activeAlerts: "Alertas activas",
    noActiveAlerts: "No hay alertas activas",
    noActiveAlertsHelp:
      "Las alertas abiertas de Element aparecerán aquí con acciones para confirmarlas y resolverlas.",
    acknowledge: "Confirmar",
    resolve: "Resolver",
    reviewTelemetry: "Revisa la telemetría del dispositivo.",
    unassignedZone: "Zona sin asignar",
    quickInsights: "Información rápida",
    complianceSummary: "Resumen de cumplimiento",
    currentStatus: "Estado actual",
    latest: "Último: {title} · {date}",
    complianceReport: "Informe de cumplimiento",
    noCompliance: "Aún no se han generado informes de cumplimiento",
    noComplianceHelp:
      "Los registros de cumplimiento de Element resumirán las evidencias generadas de seguridad, higiene y supervisión cuando se habiliten los informes.",
    recentActivity: "Actividad reciente",
    telemetry: "Telemetría de Element",
    noActivity: "No hay actividad reciente",
    noActivityHelp:
      "Las alertas, lecturas y acciones sobre alertas aparecerán aquí cuando los dispositivos envíen telemetría.",
    trend: "Tendencia de las últimas 24 h",
    readingCounts: "Número de lecturas por hora",
    noTrend: "Aún no hay lecturas de las últimas 24 h",
    noTrendHelp:
      "Las barras de tendencia aparecerán cuando se reciba telemetría en directo de los dispositivos Milesight.",
  },
  insight: {
    hardwareReadyTitle: "Hardware listo para adoptar",
    hardwareReadyDetail:
      "Adopta el hardware una sola vez y asigna después los sensores a las zonas.",
    offlineOne: "{count} dispositivo sin conexión",
    offlineMany: "{count} dispositivos sin conexión",
    offlineDetail: "Revisa la última conexión y la conectividad LoRaWAN.",
    alertsOne: "{count} alerta activa",
    alertsMany: "{count} alertas activas",
    alertsDetail:
      "Confirma o resuelve las alertas en el panel Alertas activas.",
    zonesOne: "{count} zona esperando sensores",
    zonesMany: "{count} zonas esperando sensores",
    zonesDetail:
      "Asigna sensores adoptados y sin asignar a las zonas supervisadas.",
    awaitingTitle: "Esperando las primeras lecturas",
    awaitingDetail:
      "El punto de ingesta está listo para recibir datos mediante API/MQTT de Milesight.",
    sustainabilityTitle: "Puntuación de sostenibilidad: {score}",
    sustainabilityDetail: "Último cálculo de sostenibilidad de Element.",
    stableTitle: "Instalación Element estable",
    stableDetail:
      "No se han detectado excepciones activas en las zonas supervisadas.",
  },
  activity: {
    readingTitle: "Lectura de {metric} recibida",
    actionTitle: "{action} registrada",
  },
  alert: {
    fallbackTitle: "Alerta de Element",
    unknownDevice: "Dispositivo desconocido",
    assignedTo: "Asignada a {name}",
    acknowledgedBy: "Confirmada por {name}",
    notAcknowledged: "Sin confirmar",
    takeOwnership: "Asumir responsabilidad",
    auditTrail: "Historial de auditoría",
    auditDescription: "Eventos del ciclo de vida de {title}.",
    search: "Buscar alertas",
    exportSoon: "Exportar CSV (próximamente)",
    exportSoonTitle: "La exportación CSV estará disponible próximamente",
    exportSoonHelp:
      "La exportación estará disponible próximamente; falta conectar la exportación CSV del centro de alertas.",
    loading: "Cargando alertas…",
    centreHelp:
      "Alertas activas, confirmadas, resueltas, suprimidas y escaladas de Privana Element con contexto de responsabilidad operativa.",
    historyLoadFailed: "No se pudo cargar el historial de alertas",
    actionComplete: "Acción «{action}» completada",
    ownershipComment: "Asumida desde el centro de alertas",
    manageTitle: "Gestionar alertas",
    manageHelp:
      "Crea, edita, desactiva y revisa las reglas de umbral de alertas de Privana Element.",
    manageGroups: "Gestionar grupos de sensores",
    createRule: "Crear regla de alerta",
    existingRules: "Reglas de alerta existentes",
    loadingRules: "Cargando reglas…",
    noRules: "No hay reglas de alerta configuradas",
    noRulesHelp:
      "Crea una regla de batería, humedad, temperatura, señal, estado en línea o falta de comunicación para comenzar a supervisar umbrales.",
    recipients: "Destinatarios: {recipients}",
    duration: "Duración: {duration}",
    cooldown: "Intervalo: {duration}",
    channels: "Canales: {channels}",
    autoResolve: "Resolución automática: {value}",
    notifyResolve: "Notificar al resolver: {value}",
    escalations: "Escalados: {value}",
    noStaff: "No hay personal seleccionado",
    recentHistory: "Historial reciente de activaciones y resoluciones",
    sendTest: "Enviar alerta de prueba",
    testSent: "Alerta de PRUEBA enviada",
    testSentHelp:
      "La notificación de prueba se registró y etiquetó como PRUEBA.",
    deactivated: "Regla de alerta desactivada",
    deactivateFailed: "No se pudo desactivar",
    saved: "Regla de alerta guardada",
    savedHelp: "Se han actualizado los umbrales de alerta de Privana Element.",
    saveFailed: "No se pudo guardar la regla de alerta",
    rulesLoadFailed: "No se pudieron cargar las reglas de alerta",
    status: {
      active: "Activas",
      acknowledged: "Confirmadas",
      resolved: "Resueltas",
      suppressed: "Suprimidas",
    },
    rule: {
      edit: "Editar regla de alerta",
      create: "Crear regla de alerta",
      help: "Configura una condición o exige que varias condiciones se mantengan verdaderas durante el periodo.",
      save: "Guardar regla",
      name: "Nombre de la regla",
      namePlaceholder: "Batería por debajo del 10 %",
      severity: "Gravedad",
      scope: "Alcance",
      allSensors: "Todos los sensores",
      specificSensor: "Sensor específico",
      specificZone: "Zona específica",
      specificGateway: "Gateway específico",
      sensorGroupScope: "Grupo de sensores / varios sensores",
      sensorGroup: "Grupo de sensores",
      selectGroup: "Seleccionar grupo de sensores",
      noGroups:
        "No hay grupos de sensores configurados. Crea uno desde Gestionar grupos de sensores.",
      durationBefore: "Tiempo antes de activar",
      customMinutes: "Minutos personalizados",
      repeatInterval: "Intervalo de repetición",
      ruleCap: "Límite diario de notificaciones de la regla",
      deviceCap: "Límite diario de notificaciones del dispositivo",
      cycleCap: "Límite de notificaciones por ciclo del proceso",
      conditions: "Condiciones",
      conditionsHelp:
        "Deben cumplirse todas las condiciones. Añade filas de humedad y temperatura para crear reglas compuestas.",
      addCondition: "Añadir condición",
      remove: "Eliminar",
      minutesNotReporting: "Minutos sin informar",
      threshold: "Umbral",
      escalationPath: "Ruta de escalado",
      escalationHelp:
        "El nivel 1 usa los destinatarios iniciales. Los niveles 2 y 3 se envían una vez si la alerta sigue sin resolver tras los minutos configurados.",
      escalateAfter: "Escalar después de (minutos)",
      fallbackEmails: "Correos alternativos",
      staffRecipients: "Destinatarios del personal",
      staffRecipientsHelp:
        "Las notificaciones de Mensajes de Privana requieren usuarios del personal seleccionados. El correo también usa sus direcciones laborales.",
      messagesNotification: "Notificación por Mensajes de Privana",
      autoResolveNormal: "Resolver automáticamente al normalizarse",
      notifyOnResolve: "Notificar al resolver",
      manualEmails: "Correos de destinatarios manuales (avanzado/alternativo)",
      selectedRequired:
        "Selecciona al menos un destinatario del personal para Mensajes de Privana.",
      scopeSensor: "Sensor: {name}",
      scopeZone: "Zona: {name}",
      scopeGateway: "Gateway: {name}",
      scopeGroup: "Grupo de sensores: {name}",
      notReporting: "{metric} sin informar durante {minutes} minutos",
      comparison: "{metric} {condition} {value}",
      escalationSummary:
        "N{level} después de {minutes} min ({staff} empleados, {emails} correos, {channels})",
    },
    groups: {
      title: "Gestionar grupos de sensores",
      help: "Crea grupos de sensores Element independientes de las zonas para dirigir las alertas.",
      name: "Nombre del grupo",
      namePlaceholder: "Todos los congeladores",
      saved: "Grupo de sensores guardado",
      archived: "Grupo de sensores archivado",
      save: "Guardar grupo",
      create: "Crear grupo",
    },
  },
  hardware: {
    adoptedTitle: "Hardware adoptado",
    adoptedHelp: "Gateways y sensores registrados en este club.",
    manage: "Gestionar hardware",
    adopting: "Adoptando…",
    adopt: "Adoptar hardware",
    totalSensors: "Total de sensores adoptados",
    totalGateways: "Total de gateways",
    unassignedSensors: "Sensores sin asignar",
    offlinePending: "Dispositivos sin conexión/pendientes",
    overview: "Resumen",
    gateways: "Gateways",
    sensors: "Sensores",
    adoptTab: "Adoptar hardware",
    gatewaysAdopted: "Gateways adoptados",
    sensorsAdopted: "Sensores adoptados",
    pendingActivation: "Activación pendiente",
    onlineDevices: "Dispositivos en línea",
    overviewTitle:
      "Adopta el hardware una sola vez y asigna después los sensores a las zonas.",
    overviewHelp:
      "Los gateways permanecen como infraestructura del club. Los sensores permanecen en inventario hasta que se asignen a una zona supervisada.",
    overviewAssignHelp:
      "Los sensores se asignan a las zonas desde cada zona. Usa «Asignar sensor» dentro de una zona para desplegar el hardware.",
    noGateways: "No hay gateways adoptados",
    noGatewaysHelp:
      "Adopta un gateway para registrar la infraestructura de red del club.",
    noSensors: "No hay sensores adoptados",
    noSensorsHelp:
      "Adopta sensores y asigna después los disponibles a las zonas.",
    gatewayModelMissing: "No se ha seleccionado el modelo del gateway",
    sensorModelMissing: "No se ha seleccionado el modelo del sensor",
    gatewayEui: "EUI del gateway",
    sensorsUsingGateway: "Sensores que usan el gateway",
    connectionType: "Tipo de conexión",
    edit: "Editar",
    endMaintenance: "Finalizar mantenimiento",
    startMaintenance: "Poner en mantenimiento",
    editHardware: "Editar {kind}",
    editHelp: "Actualiza los detalles del hardware adoptado.",
    provisioningStatus: "Estado de aprovisionamiento",
    protectedIdentity: "Identidad protegida de ChirpStack.",
    save: "Guardar hardware",
    updated: "Hardware actualizado",
    updatedHelp: "Se guardaron los detalles del hardware adoptado.",
    updateFailed: "No se pudo actualizar el hardware",
    adopted: "Hardware adoptado",
    adoptedSuccess: "El dispositivo ya está registrado en este club.",
    adoptionFailed: "No se pudo adoptar",
    deactivated: "Dispositivo desactivado",
    deactivatedHelp: "Se conservaron las lecturas y alertas históricas.",
    deactivateFailed: "No se pudo desactivar",
    deactivateTitle: "Desactivar dispositivo",
    deactivatePrompt:
      "¿Desactivar este dispositivo? Se conservarán las lecturas y alertas históricas.",
    deactivateAction: "Desactivar dispositivo",
    assignTitle: "Asignar sensor",
    assignHelp: "Selecciona un sensor adoptado y sin asignar para {zone}.",
    thisZone: "esta zona",
    unassignedSensor: "Sensor sin asignar",
    noModel: "Sin modelo",
    noAssignable: "No hay sensores que se puedan asignar",
    noAssignableHelp:
      "Adopta primero un sensor nuevo y asígnalo después a esta zona.",
    adoptInstead: "Adoptar un sensor nuevo",
    assign: "Asignar sensor",
    assigned: "Sensor asignado",
    assignedHelp: "Se ha actualizado la lista de dispositivos de {zone}.",
    assignFailed: "No se pudo asignar",
    unassignedToast: "Sensor desasignado",
    unassignedHelp: "El sensor volvió al inventario sin asignar.",
    unassignFailed: "No se pudo desasignar",
    editAssignment: "Editar asignación",
    unassignFromZone: "Desasignar de la zona",
    actionsLabel: "Abrir acciones de {name}",
    maintenanceTitle: "Poner en mantenimiento",
    maintenanceHelp:
      "Suprime las notificaciones de alerta de este dispositivo o gateway mientras se siguen registrando lecturas.",
    maintenanceReason: "Motivo del mantenimiento",
    maintenancePlaceholder:
      "Cambio de baterías, reubicación del gateway, calibración…",
    optionalEnd: "Fecha/hora de finalización opcional",
    startMaintenanceAction: "Iniciar mantenimiento",
    maintenanceEnabled: "Modo de mantenimiento habilitado",
    maintenanceEnabledHelp: "Se suprimirán las notificaciones de {device}.",
    maintenanceEnded: "Mantenimiento finalizado",
    maintenanceEndedHelp:
      "Se reanudaron las notificaciones de alerta de {device}.",
    maintenanceFailed: "No se pudo cambiar el mantenimiento",
    adoption: {
      step: "Paso 1: elige el tipo de hardware",
      regionResolved: "Región LoRaWAN: {region}, obtenida de {source}.",
      regionClubCountry: "país del club: {country}",
      regionMissing:
        "No se pudo obtener la región LoRaWAN de la dirección del club. Completa la dirección antes de adoptar hardware LoRaWAN.",
      gatewayName: "Nombre del gateway",
      gatewayNamePlaceholder: "Gateway principal de la casa club",
      gatewayModel: "Modelo/catálogo del gateway",
      serialOptional: "Número de serie (opcional)",
      serialPlaceholder: "Número de serie Milesight",
      locationPlaceholder: "Rack de la sala de TI",
      sensorName: "Nombre del sensor",
      sensorNamePlaceholder: "Sensor de fugas de los aseos",
      sensorModel: "Modelo/catálogo del sensor",
      preferredGateway: "Gateway/red preferido",
      pairingCode: "Código de emparejamiento / QR / número de serie",
      pairingPlaceholder: "Referencia de serie o QR opcional",
      sensorLocationPlaceholder: "Debajo del lavabo 2",
      notesPlaceholder: "Notas de instalación opcionales",
      gatewayHelp:
        "Los gateways necesitan un EUI para ChirpStack. El número de serie es opcional y se conserva separado del EUI.",
      scanQr: "Escanear código QR",
      scanQrHelp:
        "Escanea el código QR de la etiqueta o del embalaje del sensor. Privana extraerá automáticamente los datos LoRaWAN.",
      scanCamera: "Escanear con la cámara",
      scanPhone: "Escanear con el teléfono",
      scanPhoneHelp:
        "Abre este QR de emparejamiento en un teléfono junto al sensor. El escáner móvil enviará DevEUI, JoinEUI/AppEUI, AppKey y el modelo detectado a esta sesión del ordenador.",
      waitingPhone: "Esperando el escaneo del teléfono…",
      newQr: "Nuevo QR de emparejamiento",
      pasteQr: "Pega aquí el texto del QR si no puedes usar la cámara",
      pasteQrLabel: "Pegar texto del QR",
      parseQr: "Procesar código QR",
      stopCamera: "Detener cámara",
      credentials: "Credenciales LoRaWAN",
      appKeyCaptured: "AppKey capturada{ending}.",
      appKeyMissing: "Todavía no se ha capturado la AppKey.",
      devEui: "DevEUI",
      joinEui: "JoinEUI/AppEUI",
      serialNotFound: "Aún no encontrado",
      nextStep:
        "Siguiente paso: busca JoinEUI/AppEUI y AppKey en Milesight ToolBox o en la hoja de aprovisionamiento del dispositivo.",
      manualTitle: "Datos LoRaWAN manuales — Avanzado",
      manualHelp:
        "La introducción manual está reservada a instaladores técnicos.",
      appKeyEncrypted: "Se guardará cifrada tras la adopción",
      milesightHelp:
        "La AppKey predeterminada de Milesight suele ser el DevEUI repetido dos veces. Sustitúyela si la hoja de aprovisionamiento indica otra.",
      qrReady:
        "{source} procesado. Los datos LoRaWAN están listos para la adopción.",
      qrSerialOnly:
        "Se encontró el QR, pero solo contiene el número de serie. Siguen faltando las claves LoRaWAN.",
      qrMissingKeys: "Se encontró el QR, pero siguen faltando JoinEUI/AppKey.",
      qrNoCredentials:
        "Se encontró {source}, pero no contiene credenciales LoRaWAN.",
      phoneSource: "Escaneo del teléfono",
      phoneModel:
        "Escaneo del teléfono recibido. Modelo del sensor detectado: {model}",
      phoneUpdated:
        "Escaneo del teléfono recibido. Se han actualizado los campos del ordenador.",
      phoneUnavailable:
        "No se pudo conectar el emparejamiento con el teléfono. Pega el texto del QR.",
      requestingCamera: "Solicitando permiso para usar la cámara…",
      cameraActive:
        "Cámara activa: llena el recuadro con el código QR. Toca la vista previa para enfocar.",
      scanNoCredentials:
        "Se encontró el QR, pero no contiene credenciales LoRaWAN. Escanéalo de nuevo o pega el texto.",
    },
  },
  device: {
    edit: "Editar dispositivo",
    add: "Añadir dispositivo",
    formHelp:
      "Selecciona el modelo del catálogo y gestiona solo los datos operativos que se muestran al personal.",
    zone: "Zona",
    typeModel: "Tipo de dispositivo / modelo del catálogo",
    name: "Nombre del dispositivo",
    namePlaceholder: "Monitor del frigorífico de cocina",
    locationPlaceholder: "Pared norte",
    maintenanceDue: "Fecha límite de mantenimiento",
    save: "Guardar dispositivo",
    added: "Dispositivo añadido",
    updated: "Dispositivo actualizado",
    refreshed:
      "Se han actualizado las asignaciones de dispositivos de la zona.",
    saveFailed: "No se pudo guardar el dispositivo",
  },
  pairing: {
    connecting: "Conectando con Privana…",
    title: "Escanear el QR del sensor",
    subtitle:
      "Privana enviará los datos LoRaWAN al cuadro de adopción del ordenador.",
    boxHelp: "Llena el recuadro con el código QR. Toca para enfocar.",
    standby: "Escáner de cámara en espera",
    uploadFallback: "Alternativa: subir/hacer una foto",
    upload: "Subir/hacer una foto",
    toolboxHelp:
      "Busca JoinEUI/AppEUI y AppKey en Milesight ToolBox o en la hoja de aprovisionamiento del dispositivo.",
    pasteFallback: "Alternativa: pegar el texto del QR",
    pastePlaceholder: "Pega el texto del QR si no puedes usar la cámara",
    stopCamera: "Detener cámara",
    startCamera: "Iniciar escáner de cámara",
    send: "Enviar",
    qrSource: "Código QR",
    qrReady: "{source} procesado. Los datos LoRaWAN están listos.",
    qrSerialOnly:
      "Se encontró el QR, pero solo contiene el número de serie. Siguen faltando las claves LoRaWAN.",
    qrMissingKeys: "Se encontró el QR, pero siguen faltando JoinEUI/AppKey.",
    qrNoCredentials:
      "Se encontró {source}, pero no contiene credenciales LoRaWAN. Escanéalo de nuevo, haz una foto o pega el texto.",
    sentReady:
      "Los datos LoRaWAN se enviaron al cuadro de adopción del ordenador.",
    sentPartial: "{status} Los datos se enviaron al cuadro del ordenador.",
    requestingCamera: "Solicitando permiso para usar la cámara…",
    cameraActive:
      "Cámara activa: llena el recuadro con el código QR. Toca la vista previa para enfocar.",
    connectedReopen: "Conectado. Reabriendo el último escáner de cámara…",
    connectedReady:
      "Conectado. Toca Iniciar escáner de cámara o Subir/hacer una foto.",
    decoding: "Leyendo el QR de la foto…",
    diagnostics: "Diagnóstico del QR",
    diagnosticsMediaDevices: "¿Está disponible navigator.mediaDevices?",
    diagnosticsGetUserMedia: "¿Está disponible el acceso multimedia a la cámara?",
    diagnosticsSecureContext: "¿Contexto seguro del navegador?",
    diagnosticsLocation: "Ubicación de la página",
    diagnosticsLoaded: "¿El escáner QR se ha cargado correctamente?",
    diagnosticsStartError: "Error al iniciar el escáner QR",
    warnings: {
      empty: "Pega o escanea primero un código QR.",
      serialOnly:
        "Se encontró el QR, pero solo contiene el número de serie. Siguen faltando las claves LoRaWAN.",
      missingKeys: "Se encontró el QR, pero siguen faltando JoinEUI/AppKey.",
      partial:
        "Se encontraron algunos datos LoRaWAN, pero se necesitan tanto JoinEUI/AppEUI como AppKey.",
      none: "No se encontraron credenciales LoRaWAN. Pega el texto completo del QR o usa los datos LoRaWAN manuales.",
      toolbox:
        "Busca JoinEUI/AppEUI y AppKey en Milesight ToolBox o en la hoja de aprovisionamiento del dispositivo.",
      invalidHex: "{field} debe tener {count} caracteres hexadecimales.",
    },
  },
};
